import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=4e65c4fb&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=4e65c4fb&lang=scss"
import style1 from "./Header.vue?vue&type=style&index=1&id=4e65c4fb&lang=scss&scoped=true"
import style2 from "./Header.vue?vue&type=style&index=2&id=4e65c4fb&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e65c4fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e65c4fb')) {
      api.createRecord('4e65c4fb', component.options)
    } else {
      api.reload('4e65c4fb', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=4e65c4fb&scoped=true", function () {
      api.rerender('4e65c4fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Header.vue"
export default component.exports